import * as React from 'react';
import {IconButton, Dialog} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment/moment';
import {AppCustomConfirmationDialog} from './AppCustomConfirmationDialog';
import {EditAgenceName} from './EditAgenceName';

export const AgenceTableRow = ({row, keyIndex, onEdit, onClick, onDelete}) => {
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    const [openEditDialog, setOpenEditDialog] = React.useState(false);

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
    };

    const handleEditClick = () => {
        setOpenEditDialog(true);
    };

    const handleCloseEditDialog = () => {
        setOpenEditDialog(false);
    };

    const handleEditSuccess = () => {
        if (onEdit) {
            onEdit();
        }
    };

    const deleteAgence = () => {
        if (row && onDelete) {
            onDelete(row._id);
        }
        handleCloseDeleteDialog();
    };

    const handleRowClick = () => {
        if (onClick && row) {
            onClick(row);
        }
    };

    return (
        <>
            <tr
                key={keyIndex}
                onClick={handleRowClick}
                style={{
                    cursor: "pointer",
                    width: "100%",
                    backgroundColor: keyIndex % 2 === 0 ? "" : ""
                }}
            >
                <td className="px-2 w-1/6 align-middle" align="left">
                    {row.nom || ''}
                </td>
                <td className="px-2 w-1/6 align-middle" align="left">
                    {row.address || ''}
                </td>
                <td className="px-2 w-1/6 align-middle" align="left">
                    {row.phone || ''}
                </td>
                <td className="px-2 w-1/6 align-middle" align="left">
                    {row.email || ''}
                </td>
                <td className="px-2 w-1/6 align-middle" align="left">
                    {row.createdAt ? moment(row.createdAt).format("DD-MM-YYYY") : ''}
                </td>
                <td className="px-2 w-1/6 align-middle" align="left">
                    {row.updatedAt ? moment(row.updatedAt).format("DD-MM-YYYY") : ''}
                </td>
                <td className="px-2 w-[7.66%] d-flex" onClick={(e) => e.stopPropagation()}>
                    <IconButton aria-label="edit" size="small" onClick={handleEditClick}>
                        <EditIcon/>
                    </IconButton>
                    <IconButton aria-label="delete" size="small" onClick={handleDeleteClick}>
                        <DeleteIcon/>
                    </IconButton>
                </td>
            </tr>

            <AppCustomConfirmationDialog
                open={openDeleteDialog}
                onClose={handleCloseDeleteDialog}
                onAccept={deleteAgence}
                onDecline={handleCloseDeleteDialog}
                title="Confirmation de suppression"
                bodyMessage={`Êtes-vous sûr de vouloir supprimer l'agence "${row.nom}" ? Cette action est irréversible.`}
                acceptButtonText="Supprimer"
                declineButtonText="Annuler"
                acceptButtonColor="error"
            />

            <Dialog
                open={openEditDialog}
                onClose={handleCloseEditDialog}
                maxWidth="sm"
                fullWidth
            >
                <EditAgenceName
                    agence={row}
                    onClose={handleCloseEditDialog}
                    onSuccess={handleEditSuccess}
                />
            </Dialog>
        </>
    );
};

export default AgenceTableRow; 